var Rx = require('rx');
require('./dist/rx.dom');
module.exports = Rx;